import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'

import theme from 'theme'
import Price from 'theme/molecules/Price'

export default function DrawerHeader() {
  const variant = useDisplayVariant()

  return (
    <Wrapper className="DrawerHeader">
      <h3 className="label">{variant.data.title}</h3>
      <div className="sub-title">{variant.data.subtitle}</div>
      <Price
        logic="piece"
        unit={variant.data.unit}
        prices={variant.data.prices}
        options={{
          amount: 1,
          isFlyoutCart: false,
          showdeliveryBadge: true,
          // renderDeliveryBadgeIfNotAvailable is set to true due to lack of desicion power...
          renderDeliveryBadgeIfNotAvailable: true,
          customTailor:
            variant.data.configurations.custom_tailor.is_custom_tailor
        }}
      />
      <span className="divider" />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > button {
    display: block;
    margin: 0 auto;
    width: 15rem;
    text-align: center;
    margin-top: ${theme.spacing('l')};
  }
  > .label {
    ${theme.ty('rc-base', '400', 'rc-2xl')}

    margin-bottom: ${theme.spacing('xxs')};
  }

  > .sub-title {
    ${theme.ty('r-xs', '400', 'r-s')};
    color: ${theme.colors.shade.b2};
    margin-bottom: ${theme.spacing('xs')};
  }

  > .divider {
    display: block;
    margin-top: 25px;
    width: 100%;
    border-bottom: 1px solid ${theme.colors.shade.b2};
  }
`
